type AsyncTryReturn = [ boolean, any, "async_try" ];

type AsyncTryReturnInfer<T> = T extends Promise<any> ? Promise<AsyncTryReturn> : AsyncTryReturn;

function async_try<T>( ps: T ): AsyncTryReturnInfer<T> {
    if ( ps instanceof Promise ) {
        return ps.then( res => {
            if ( Array.isArray( res ) && res.length >= 3 && res[2] === "async_try" ) {
                return res as AsyncTryReturn;
            }
            return [ true, res, "async_try" ] as AsyncTryReturn;
        } )
            .catch( err => {
                return [ false, err, "async_try" ] as AsyncTryReturn;
            } ) as AsyncTryReturnInfer<T>;
    }

    return [ true, ps, "async_try" ] as AsyncTryReturnInfer<T>;
}

export { async_try, type AsyncTryReturn };
